import moment from 'moment';
import Vue from 'vue';
import sanitizeHtml from "sanitize-html/dist/sanitize-html.min";

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('Do MMM HH:mm');
  }
});
Vue.filter('ucFirst', function (value) {
  if (value){
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
});
Vue.filter('formatDateDay', function (value) {
    let date = moment(value, 'YYYY-MM-DD hh:mm:ss');
    let currentDate = moment();
    let days_till = Math.round((date - currentDate) / (24*60*60*1000));
    let hours = String(moment(date).format("HH:mm"));

    if (days_till === 0) {
      date = "<b>" + "Today" + "</b>, "+ hours;
    } else if (days_till === 1) {
      date = "<b>" + "Tomorrow" + "</b>, " + hours;
    } else {
      let day = String(moment(date).format("ddd DD MMM"));
      date = "<b>" + day + "</b> " + hours;
    }

    return date;
});
Vue.filter('makeBool', function (value) {
  return (value === "1");
});
Vue.filter('slotFilter', function (value) {
  let title = value.name;
  let date = moment(value.date_start).format("ddd DD MMM [']YY / HH:mm");

  return title + " @ " + date;
});
Vue.filter('unitFormatter', function (value) {
  let units = '';

  if (typeof value !== 'undefined') {
    for (let i = 0; i < value.length; i++) {
      if (i < value.length - 1) {
        units += value[i].name + ", ";
      } else {
        units += value[i].name;
      }
    }
  }

  return units;
});
Vue.filter('renderHtml', function (value) {
  return String(sanitizeHtml(value, {
    transformTags: {
      '*': 'h3'
    }
  })).replace(/<h3>/gi, " ").replace(/<\/h3>/gi, ""); // We basically transform all tags into h3, and then replace all those
});
Vue.filter('dateTarget', function (value) {
  return moment(value).format("MMM Do 'YY");
});
Vue.filter('actionStatusIcon', function (value) {
  let icon = "";
  value = value.toLowerCase();

  switch (value) {
    case 'done':
      icon = '<i class="ti-check text-success"></i>';
      break;
    case 'accept':
      icon = '<i class="ti-more-alt text-info"></i>';
      break;
    case 'declined':
      icon = '<i class="ti-close text-danger"></i>';
      break;
    case 'pending':
      icon = '<i class="ti-settings text-info"></i>';
      break;
  }

  icon = icon + ' ' + value;

  return icon;
});
Vue.filter('formatNumber', function (value) {
  if (isNaN(value)){
    return "-";
  }
  return parseInt(value).toLocaleString(undefined, { minimumFractionDigits: 0});
});
Vue.filter('cutText', function (value, length) {
  if (typeof value !== "undefined") {
    if (value.length > length) {
      return value.substr(0, length) + "...";
    } else {
      return value;
    }
  }
});
Vue.filter('startTimeFilter', function(value) {
  let absValue = Math.abs(value);

  if (absValue < 60) {
    absValue = absValue + " minutes";
  } else if (absValue < 1440) {
    absValue = Math.floor(absValue / 60);
    if (absValue === 1) {
      absValue = absValue + " hour";
    } else {
      absValue = absValue + " hours";
    }
  } else {
    absValue = Math.floor(absValue / 1440);
    if (absValue === 1) {
      absValue = absValue + " day";
    } else {
      absValue = absValue + " days";
    }
  }

  if (value < 0) {
    absValue = "Meeting started " + absValue + " ago.";
  } else {
    absValue = "Meeting starts in " + absValue + ".";
  }

  return absValue;

});
Vue.filter('depthFilter', function(value) {
  value = value < 0 ? 0 : value;
  String.prototype.repeat = function( num )
  {
    return new Array( num + 1 ).join( this );
  };
  return "\xA0".repeat(value * 4);
  // value * 4 * '&nbsp;'
});




// WEBPACK FOOTER //
// ./src/filters.js